import React from 'react';

import Review from '../../../Admin/Customer/Loans/Review';
import { hot } from 'react-hot-loader';

function BaseDetail({ currentUser }) {
	// NOSONAR

	return <Review currentUser={currentUser} />;
}

export default hot(module)(BaseDetail);
